/**
 * Ad settings and constants.
 */

/**
 * Sizes
 */

// We pass the sizes we want to GPT using sizes-from-{min-width} parameters on the element,
// but Pubwise tells Prebid what to bid on based on the element ID. Because of this,
// the IDs and sizes are implicitly connected. To minimize confusion, I'm trying to tie them together in code.
//
// If you change breakpoints, sizes, or the ID format on a programmatic-elligible format, inform Pubwise.

export const AD_SIZES = {
  // Native only, no programmatic
  NATIVE: {
    idFormat: "gpt-native-{}",
    props: {
      "sizes-from-0": "2x2",
    },
  },

  // Standard full-width ad
  INJECTOR: {
    idFormat: "gpt-unit-{}",
    props: {
      "sizes-from-0": "320x450,300x250,300x50,320x50,fluid",
      "sizes-from-745": "320x450,728x90,300x250,fluid",
      "sizes-from-1000": "970x350,970x250,970x90,728x90,300x250,fluid",
    },
  },

  // Only use tiny banners on mobile to avoid taking up too much space.
  // This is good for "bumpers" around iframes, e.g., AmuseLab games
  BUMPER: {
    idFormat: "gpt-bumper-{}",
    props: {
      "sizes-from-0": "300x50,320x50",
      "sizes-from-745": "728x90,300x50,320x50",
      "sizes-from-1000": "970x350,970x250,970x90,728x90,fluid",
    },
  },
};
